import CircularProgressBar from 'infrastructure/js/components/CircularProgressBar/circularProgressBar';
import PropTypes from 'prop-types';
import MessageDialog from 'infrastructure/js/components/Dialog/MessageDialog/messageDialog';
import cn from 'classnames';
import MobileHeader from '../Common/MobileHeader/mobileHeader';
import ArrowLeftIcon from 'infrastructure/assets/svg/tab-arrow-left.svg';
import MobileBottom from '../Common/MobileBottom/mobileBottom';
import FullScreenToggle from 'infrastructure/js/components/FullScreenToggle/fullScreenToggle';
import useLabels from 'infrastructure/js/hooks/useLabels';

require('./moveAssetsResultPage.scss');


const getDetails = (succeeded, failed, withWarnings) => {
  let details = [];

  if (succeeded) {
    details.push(<MessageDialog.StatusRow key='succeededRow' type={'succeeded'} count={succeeded} />);
  }
  if (failed) {
    details.push(<MessageDialog.StatusRow key='failedRow' type={'failed'} count={failed} />);
  }
  if (withWarnings) {
    details.push(<MessageDialog.StatusRow key='warningRow' type={'warning'} count={withWarnings} />);
  }

  return details;
}

export default function MoveAssetsResultPage ({ result={},
                                            history,
                                   }) {
  const labels = useLabels('mat.mobile.moveAssetsResultPage.');

  const { numberOfSucceededItems: succeeded,
          numberOfFailedItems: failed,
          numberOfItemsWithWarnings: withWarnings,
          totalJobItems: total,
        } = result;

  const percentage = total ? Math.floor((succeeded + withWarnings) * 100 / total) : 0;

  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'leftButton',
          icon: ArrowLeftIcon,
          className: 'divider-right',
          action: () => history?.replace('/Mobile'),
        },
        {
          id: 'assetDetails',
          label: labels.get('header.title'),
        },
        {
          id: 'fullScreenButton',
          className: 'divider-left',
          buttonComponent: FullScreenToggle
        },
      ]
    }
  }

  const getBottomItems = () => {
    return {
      buttons: [
        {
          id: 'newScanButton',
          action: () => {history.replace('/MoveAssets')},
          label: labels.get('bottom.button.newScan'),
        },
      ]
    };
  };

  return (
    <div className={cn('move-assets-result',
                      {'succeeded': succeeded === total},
                      {'failed': failed === total},
                      {'partial': failed  && failed < total})}
      >

      <MobileHeader {...getHeaderItems()} />

      <div className="result-body">
        <CircularProgressBar radius={150} strokeWidth={14} percentage={percentage}/>
        <div className="bottom-label">{getDetails(succeeded, failed, withWarnings)}</div>
      </div>

      <MobileBottom {...getBottomItems()}/>
    </div>
  )
}


MoveAssetsResultPage.propTypes = {
  result: PropTypes.object.isRequired,
};
